// แบนเนอร์บนสุด: ดึงจาก API (/api/v1/tabbannerlist) — ถ้าหลังบ้านยังไม่มี ใช้รูปເກົ່າของธีม
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import instance from './axios-instance';
import Systems from './SystemFunction';

const CACHE_KEY = 'heroBannerCache_' + Systems;

export default function HeroBanner({ fallback = [] }) {
  const [list, setList] = useState(() => {
    try { const c = JSON.parse(localStorage.getItem(CACHE_KEY)); return Array.isArray(c) ? c : []; } catch (e) { return []; }
  });
  useEffect(() => {
    instance.get('/api/v1/tabbannerlist?System=' + Systems)
      .then((res) => {
        if (res.data.status === 200 && Array.isArray(res.data.message)) {
          const urls = res.data.message.map((b) => b && b.path).filter(Boolean);
          setList(urls);
          try { localStorage.setItem(CACHE_KEY, JSON.stringify(urls)); } catch (e) { /* ignore */ }
        }
      })
      .catch(() => { });
  }, []);
  const slides = list.length ? list : fallback;
  if (!slides.length) return null;
  return (
    <div className="ufa-hero">
      <Slider fade infinite autoplay autoplaySpeed={4000} speed={600} arrows={false} dots slidesToShow={1} slidesToScroll={1}>
        {slides.map((src, i) => (
          <div key={i}><img className="ufa-hero-img" src={src} alt={'banner ' + (i + 1)} /></div>
        ))}
      </Slider>
    </div>
  );
}
